export const noop = () => {}
export type Maybe<T> = T | null

export * from './castTouchToMouseEvent'
export * from './detectMouseButton'
export * from './doObjectsCollide'
export * from './getBoundsForNode'
export * from './nodeInRoot'



// WEBPACK FOOTER //
// ./src/components/react-selectable-fast/utils/index.ts